/**
 * Date-extensions locale Nynorsk [nn]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('nn', {
    monthNames: ['Januar','Februar','Mars','April','Mai','Juni','Juli','August','September','Oktober','November','Desember'],
    monthShortNames: ['Jan','Feb','Mar','Apr','Mai','Jun','Jul','Aug','Sep','Okt','Nov','Des'],
    dayNames: ['Sundag','Måndag','Tysdag','Onsdag','Torsdag','Fredag','Laurdag'],
    dayShortNames: ['Sun','Mån','Tys','Ons','Tor','Fre','Lau']
});
